import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  putUserPreferences,
  UserPreferencesPayload,
} from "../../api/userPreferences";
import { USER_PREFERENCES_QUERY_KEY } from "../queries/useUserPreferences";

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UserPreferencesPayload) =>
      putUserPreferences(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_PREFERENCES_QUERY_KEY });
    },
  });
}
